import FormattedTemperatureRange from './FormattedTemperatureRange';

export default FormattedTemperatureRange;
